import { routeChangeBegan } from '../actionUtils';
import history from "../../../common/history";
import { Routes } from '../../../common/routing';
import { Routes as ConstantRoutes, Application } from '../../../common/constants';
import { retrieveSessionStorage } from '../../../common/storageUtils';
import { getEnvironmentVariables } from '../../../common/utils';

const routeManager = (param) => (store) => (next) => (action) => {
    if (action.type !== routeChangeBegan.type) {
        return next(action);
    }
    const { intent, route, parameters } = action.payload;
    switch (intent) {
        case 'logout':
            // Redirect back to the page user was on before logout with full page refresh
            const redirectUrl = retrieveSessionStorage(Application.StorageKeys.Navigation.RedirectUrl);
            const targetUrl = redirectUrl?.pathname || `${getEnvironmentVariables().REACT_APP_APPLICATION_PUBLIC_URL}${Routes.Application.Identity.Login}`;
            // Force full page refresh even if navigating to the same URL
            if (window.location.href === targetUrl) {
                window.location.reload();
            } else {
                window.location.href = targetUrl;
            }
            break;
        case 'login':
            break;
        case 'dashboard':
            history.push(`${ConstantRoutes.Marketplace.Pages.Landings.Dashboard}/${parameters.appSpaceId}?productId=${parameters.productId}`);
            break;
        case 'external-payment-authentication':
            window.location = route
            break;
        default:
            break;
    }

    next(action);
};

export default routeManager;